import React from 'react';
import PropTypes from 'prop-types';

// React-shared.
import Portal from '@exonet/react-shared/lib/Elements/Portal';

// Components.
import CreateButton from 'app/client/components/CreateButton';
import Restricted from 'app/client/components/Restricted';

// Styled.
import * as S from './styled';

const PageHeader = ({ title, render, translations, create }) => {
  const createButton = create ? (
    <Portal
      renderTrigger={({ onOpen }) => (
        <CreateButton
          onClick={onOpen}
          type={translations?.singular}
          customLabel={create.customLabel}
        />
      )}
      render={create.renderModal}
    />
  ) : null;

  return (
    <S.PageHeader
      title={translations ? translations.plural : title}
      render={() => (
        <>
          {render && render()}
          {createButton &&
            (create.permission ? (
              <Restricted to={[create.permission]} noError>
                {createButton}
              </Restricted>
            ) : (
              createButton
            ))}
        </>
      )}
    />
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  render: PropTypes.func,
  translations: PropTypes.shape({
    singular: PropTypes.string,
    plural: PropTypes.string,
  }),
  create: PropTypes.shape({
    permission: PropTypes.string,
    renderModal: PropTypes.func,
    customLabel: PropTypes.shape({
      full: PropTypes.string,
      small: PropTypes.string,
    }),
  }),
};

export default PageHeader;
